
export default {
    props: {
        title: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            opened: false,
        }
    },
    methods: {
        toggle() {
            this.opened = !this.opened
            this.$emit('toggle')
        }
    }
}
